<template>
    <tr class="no_edit">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="macAddress.id"
                 :value="macAddress.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="macAddress.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td :data-th="'MAC Adresa' | translate" class="first_data">{{ macAddress.mac_address }}</td>
        <td :data-th="'První použití' | translate"  v-html="$_date_formatFull(macAddress.timestamp_first_usage)" />
        <td :data-th="'Poslední použití' | translate"  v-html="$_date_formatFull(macAddress.timestamp_last_usage)" />
        <td :data-th="'Datum vytvoření' | translate"  v-html="$_date_formatFull(macAddress.timestamp_created)" />
        <td :data-th="'Poslední změna' | translate"  v-html="$_date_formatFull(macAddress.timestamp_updated)" />
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
                    v-if="isEditable"
                    class="btn btn_action btn_delete"
                                        :title="'Smazat' | translate"
                    @click.stop.prevent="emitDeleteMacAddress"
                    v-translate>Smazat
				</a>
            </div>
        </td>
    </tr>
</template>

<script>
	export default {
		name: "MacAddressRow",
		props: {
			macAddress: Object,
      selectedEntities: Array,
      isEditable: Boolean,
		},
		methods: {
      onChange: function (e) {
        this.$emit('input', e)
      },
			emitDeleteMacAddress() {
				this.$emit('delete-mac-address', this.macAddress)
			}
		},
    computed: {
      isChecked() {
        return this.selectedEntities.indexOf(String(this.macAddress.id)) > -1
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/MacAddressRow.vue